var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateLetters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32.499 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8439",
    "data-name": "Group 8439",
    transform: "translate(0.243 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25025",
    "data-name": "Path 25025",
    d: "M31.458,11.677l-1.565-1.565a1.877,1.877,0,0,0-2.652,0l-3.3,3.3V2.813A2.816,2.816,0,0,0,21.132,0H2.82A2.816,2.816,0,0,0,.007,2.813V29.188A2.816,2.816,0,0,0,2.82,32H21.132a2.816,2.816,0,0,0,2.813-2.812v-7.44l7.513-7.42a1.877,1.877,0,0,0,0-2.652ZM20.245,22.766l-2.82,1.316,1.315-2.817,7-7,1.547,1.547Zm1.824,6.422a.939.939,0,0,1-.937.938H2.82a.939.939,0,0,1-.938-.937V2.813a.939.939,0,0,1,.938-.937H21.132a.939.939,0,0,1,.938.938V15.283c-5.2,5.2-4.859,4.825-4.959,5.038l-2.475,5.3a.937.937,0,0,0,1.246,1.246l5.3-2.475c.194-.091.226-.147.884-.8ZM28.62,14.5,27.064,12.94l1.5-1.5L30.132,13Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25026",
    "data-name": "Path 25026",
    d: "M65.945,98.875h14a.938.938,0,0,0,0-1.875h-14a.938.938,0,0,0,0,1.875Z",
    transform: "translate(-60.938 -90.938)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25027",
    "data-name": "Path 25027",
    d: "M65.945,178.875h11a.938.938,0,0,0,0-1.875h-11a.938.938,0,0,0,0,1.875Z",
    transform: "translate(-60.938 -165.938)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25028",
    "data-name": "Path 25028",
    d: "M73.945,257h-8a.938.938,0,0,0,0,1.875h8a.938.938,0,0,0,0-1.875Z",
    transform: "translate(-60.937 -240.938)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateLetters);
export default __webpack_public_path__ + "static/media/GenerateLetters.2cc86b343ce885644515ec709b893b31.svg";
export { ForwardRef as ReactComponent };